import { type AnyAction, combineReducers } from 'redux';

import type { Notification } from 'js/src/client';
import {
    setHasUnreadNotifications,
    setLoadingNotifications,
    setNotificationsIsEmpty,
    storeNotifications,
} from 'js/src/data/notifications/notification-actions';
import { NotificationUiState } from 'js/src/data/notifications/notification-types';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import type { DeepReadonly } from 'js/src/libs/consts';

export function notifications_list(
    state = PlainJsStoreORM.createEmpty<DeepReadonly<Notification>, number>().data,
    action: AnyAction,
) {
    if (storeNotifications.match(action)) {
        const orm = PlainJsStoreORM.createEmpty<DeepReadonly<Notification>, number>();
        action.payload.notifications_list.forEach((notification) =>
            orm.pushItem(notification, 'id'),
        );
        return orm.data;
    }
    return state;
}

export function has_unread(state = false, action: AnyAction): boolean {
    if (setHasUnreadNotifications.match(action)) {
        return action.payload.hasUnread;
    } else if (storeNotifications.match(action)) {
        return action.payload.notifications_list.some(
            (notification) => notification.read_status === false,
        );
    }

    return state;
}

export function uiState(state = NotificationUiState.EMPTY, action: AnyAction): NotificationUiState {
    if (setLoadingNotifications.match(action)) {
        const {
            payload: { isLoading },
        } = action;
        return isLoading ? NotificationUiState.LOADING : NotificationUiState.SHOWING;
    } else if (setNotificationsIsEmpty.match(action)) {
        const {
            payload: { isEmpty },
        } = action;
        return isEmpty ? NotificationUiState.EMPTY : NotificationUiState.SHOWING;
    }

    // default
    return state;
}

export const notifications = combineReducers({
    notifications_list,
    uiState,
    has_unread,
});

export type NotificationsState = ReturnType<typeof notifications>;
